export default __webpack_public_path__ + "static/media/BackPagination.c758902f.svg";